import React, { useEffect, useState } from 'react';
import { CommercialMessagesContext } from './context';
import { getVoucherMessages } from './service';
export const CommercialMessagesProvider = ({ children, localeCode, }) => {
    const [state, setState] = useState([]);
    useEffect(() => {
        let isMounted = true;
        getVoucherMessages(localeCode).then(items => {
            if (isMounted && Array.isArray(items)) {
                setState(items);
            }
        });
        return () => {
            isMounted = false;
        };
    }, [localeCode]);
    return (React.createElement(CommercialMessagesContext.Provider, { value: state }, children));
};
//# sourceMappingURL=provider.js.map